import { Box, Checkbox, FormControlLabel, Tooltip } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import CreatePortalHOC from "../GlobalFeature/Fields/CreatePortalHOC";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { createPortal } from "react-dom";
import { ReactComponent as DeleteSubTaskIcon } from "../../assets/images/deleteSubTaskIcon.svg";
import { ReactComponent as CalendarIcon } from "../../assets/images/calendarIcon.svg";
import { ReactComponent as AddProfileWithCircle } from "../../assets/images/assignedToBlue.svg";
import { ReactComponent as CircleDelete } from "../../assets/images/icons/CircleDelete.svg";
import { ReactComponent as CircleEdit } from "../../assets/images/icons/CircleEdit.svg";
import { ReactComponent as DateLight } from "../../assets/images/icons/DateLight.svg";
import { boolean } from "yup";
import { getInitials } from "../../utils/utilityFunctions/stringUtility";
import BasicSelect from "../Task/BasicSelect";
import InputComponent from "../UniversalComponents/InputComponent";
import FloatingList from "../UniversalComponents/FloatingElement";
import FieldElements from "../UniversalComponents/FieldElements";
import AvatarName from "../UniversalComponents/AvatarName";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import SelectComponent from "../UniversalComponents/SelectComponent";
import LabelComponent from "../UniversalComponents/LabelComponent";
import CompletionCheckbox from "../UniversalComponents/CompletionCheckbox";
import { ReactComponent as ActivityIcon } from "../../assets/images/icons/ActivityIcon.svg";
import { ReactComponent as PencilIcon } from "../../assets/images/icons/PencilIconUnfilled.svg";
import { ReactComponent as StopIconGrey } from "../../assets/images/icons/StopIconGrey.svg";
import { ReactComponent as ProfileIcon } from "../../assets/images/icons/profileIconTie.svg";

export const ChecklistDrawer = ({
  handleDeleteSubtask,
  customerTaskCategory,
  startDate,
  endDate,
  personTableData,
  handleSubTaskPerson,
  handleCheck,
  searchTerm,
  subTaskContainerRef,
  formData,
  handleSubtaskChange,
  handleSubtaskCheckboxChange,
  isFormDisabled,
  isEditTask,
  handleMouseEnter,
  handleMouseLeave,
  isSearchBarOpen,
  setIsSearchBarOpen,
  dropdownCoord,
  taskassignedtoref,
  subTaskSelected,
  setSubtaskSelected,
  fetchPersonData,
  checklistForm,
  setChecklistForm,
  initialChecklistForm,
  useLazyGetProjectTaskEnumQuery,
  projectFieldListLoading,
  // handleChecklistChange
  subDrawer,
  open,
  onClose,
  addSubtask,
  addChecklist,
  setFormData,
}) => {
  const [openAssignedTo, setOpenAssignedTo] = useState(false);
  const [checklistPersonSearch, setChecklistPersonSearch] = useState("");
  const [editingChecklistId, setEditingChecklistId] = useState(null);
  const handleNewSubtaskCheckboxChange = (subtask, checked, index) => {
    setSubtaskSelected((prevState) => ({ ...prevState, [index]: checked }));
  };

  const handleDeleteSubTasks = (index) => {
    handleDeleteSubtask(
      Object.keys(subTaskSelected)?.length
        ? Object.keys(subTaskSelected).filter((key) => subTaskSelected[key])
        : [String(index)]
    );
    setSubtaskSelected({});
  };

  const handleChecklistChange = (index, e) => {
    const { name, value } = e.target;
    // console.log(e.target.value, checklistForm, "hellooeee");
    if (name === "delegation") {
      let newAssignedTo = [];
      const isAlreadyAssigned = checklistForm?.delegation?.some((person) => person.id === value[0]);
      if (isAlreadyAssigned) {
        // Remove the person if already assigned
        newAssignedTo = [];
      } else {
        const selectedPerson = personTableData?.find((person) => person.id === value[0]);
        newAssignedTo = [selectedPerson];
        // console.log(selectedPerson, newAssignedTo, "hellooeee 4");
      }

      setChecklistForm((prevForm) => ({ ...prevForm, [name]: newAssignedTo }));
    } else {
      setChecklistForm((prevForm) => ({ ...prevForm, [name]: value }));
    }
  };

  const handleToggleTaskComplete = (index) => {
    const updatedCheckList = [...formData.checklists];
    // console.log(formData, updatedCheckList, "hellooeee 5");
    const currentCheckList = updatedCheckList[index];

    // If marking as Completed
    if (currentCheckList.status.toLowerCase() !== "completed") {
      updatedCheckList[index] = {
        ...currentCheckList,
        previous_status: currentCheckList.status,
        // previous_status_color_code: currentCheckList.status_color_code || "#2581D7",
        status: "Completed",
        // status_color_code: "#37BE20",
      };
    } else {
      // If unchecking, revert to previous_status
      updatedCheckList[index] = {
        ...currentCheckList,
        status: currentCheckList.previous_status || "Completed",
        // status_color_code: "#2581D7",
        previous_status: "Pending",
        // previous_status_color_code: "#37BE20",
      };
    }

    setFormData((prev) => ({
      ...prev,
      checklists: updatedCheckList,
    }));
  };

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const handleChangeSearch = (e) => {
    // console.log(e, "hitthetarget");

    setChecklistPersonSearch(e.target.value);
  };

  // const handleChecklistChange=(e)=>{
  //   const { name, value } = e.target;
  //   setChecklistForm((prevState) => ({...prevState, [name]: value}));
  // }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setChecklistForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const projectFields2 = [
    {
      id: "fs_item",
      name: "fs_item",
      label: "FS Item",
      type: "text",
      value: checklistForm?.fs_item,
      // disabled: true,
      isMandatory: true,
      colspan: 2,
    },
    {
      id: "activity",
      name: "activity",
      label: "Activity",
      type: "select",
      value: checklistForm?.activity,
      // disabled: true,
      // dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      // isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "checklist",
        field: "activity",
      },
      // apiCall: function() {
      //   return getFieldValue("return_type","job");
      // },
      // hide: checklistForm?.service === "bookeeping",
    },
    {
      id: "name",
      name: "name",
      label: "Name",
      type: "text",
      value: checklistForm?.name,
      // disabled: true,
    },
    {
      id: "type_of_issue",
      name: "type_of_issue",
      label: "Type of Issue",
      type: "select",
      value: checklistForm?.type_of_issue,
      // disabled: true,
      // dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      // isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "checklist",
        field: "type_of_issue",
      },

      // apiCall: function() {
      //   return getFieldValue("return_type","job");
      // },
      // hide: checklistForm?.service === "bookeeping",
    },
    {},

    {
      id: "delegation",
      name: "delegation",
      label: "Delegation",
      type: "delegation",
      value: checklistForm?.delegation,
      isMandatory: true,
      // disabled: true,
      // dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      // isLoading: projectFieldListLoading,
      // useFetchHook: useLazyGetProjectTaskEnumQuery,
      // hookPayload: {
      //   entity: "checklist",
      //   field: "status",
      // },
      // apiCall: function() {
      //   return getFieldValue("return_type","job");
      // },
      // hide: checklistForm?.service === "bookeeping",
    },
    {
      id: "status",
      name: "status",
      label: "Status",
      type: "select",
      value: checklistForm?.status,
      // disabled: true,
      // dynamicOptions: projectFieldList?.data?.map((eachItem) => ({ label: eachItem, value: eachItem })),
      // isLoading: projectFieldListLoading,
      useFetchHook: useLazyGetProjectTaskEnumQuery,
      hookPayload: {
        entity: "checklist",
        field: "status",
      },
      // apiCall: function() {
      //   return getFieldValue("return_type","job");
      // },
      // hide: checklistForm?.service === "bookeeping",
    },
  ];

  const getDelegationComponent = () => (
    <button type="button" ref={taskassignedtoref} disabled={isFormDisabled} className="flex">
      {/* <AddTaskProfileIcn /> */}
      <div>
        <div
          onClick={(event) => {
            taskassignedtoref.current = event.target.closest("button");
            // handleMouseEnter(index);
            setOpenAssignedTo(!openAssignedTo);
            if (!openAssignedTo) fetchPersonData("");
          }}
        >
          {checklistForm?.delegation?.length >= 1 ? (
            <Fragment>
              {checklistForm?.delegation
                ?.filter((a, index) => index < 1)
                .map((eachInput, subIndex) => {
                  const initials = eachInput?.name
                    .split(" ")
                    .filter((word) => word.length > 0)
                    .map((word) => word.charAt(0).toUpperCase())
                    .slice(0, 2)
                    .join("");

                  const fullName = eachInput?.name;

                  return (
                    <Tooltip
                      title={
                        <>
                          <div className="py-2 min-w-[249px]">
                            <div className="rounded-lg bg-white">
                              <div className="border-b-2 space-y-2 pb-2">
                                <div className="flex px-2 space-x-2">
                                  <div>
                                    <div className=" flex justify-center items-center ">
                                      <AvatarName
                                        name={initials}
                                        size="small"
                                        bgColor={"#E8ECF299"}
                                        textColor={"#7C7C83"}
                                        borderColor={"#ABABAC"}
                                      />
                                    </div>
                                  </div>
                                  <div className="text-2999BC text-14">{fullName}</div>
                                </div>

                                <div className="flex px-2 space-x-2 my-2">
                                  <div className="w-5 text-center">
                                    <EmailIcon />
                                  </div>
                                  <div className="text-F16136 text-12">{eachInput?.email}</div>
                                </div>

                                <div className="flex px-2 space-x-2 my-2">
                                  <div className="w-5 text-center">
                                    <PhoneIcon />
                                  </div>
                                  <div className="text-F16136 text-12">
                                    {eachInput?.mobile ? eachInput?.mobile : "Not Avaliable"}
                                  </div>
                                </div>
                              </div>
                              <div className="flex justify-end mt-2 me-5 text-12">
                                <button
                                  className="text-blue-500"
                                  // onClick={(e) => toggleDetails(e, header, rowKey, eachInput)}
                                >
                                  {/* {isDetailsVisible ? "Show more" : "Show more"} */}
                                  Show more
                                </button>
                              </div>
                            </div>
                            <div></div>
                          </div>
                        </>
                      }
                      PopperProps={{ style: { zIndex: 99999 } }}
                      placement="top"
                      arrow
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "common.white",
                            filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                            color: "#383838",
                            "& .MuiTooltip-arrow": {
                              color: "common.white",
                              filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                            },
                          },
                        },
                      }}
                    >
                      <div key={subIndex}>
                        <AvatarName
                          name={initials}
                          size="medium"
                          bgColor={eachInput?.c_key}
                          textColor={"#ffffff"}
                          borderColor={"#ffffff"}
                        />
                      </div>
                    </Tooltip>
                  );
                })}
            </Fragment>
          ) : (
            <AddProfileWithCircle />
          )}
        </div>
        {openAssignedTo && (
          <FloatingList>
            <div className="w-[294px]  mt-2 bg-white rounded-md border shadow-3 pt-3 mb-6 absolute z-[1]">
              <div onMouseLeave={() => setOpenAssignedTo(false)}>
                <input
                  type="text"
                  placeholder="Type a name or email address"
                  className="ml-2 w-[270px] h-[38px] border-[#B6BBBF] bg-[#F8F8F8] rounded-md text-[12px] font-[400] text-[#848687] mb-1"
                  value={checklistPersonSearch || ""}
                  onChange={handleChangeSearch}
                />

                <div className="pb-3 align-center">
                  <h3 className="text-14 font-500 ml-4 mb-1">Assigned</h3>
                  <ul className="list-none max-h-[70px] overflow-y-auto">
                    {checklistForm?.delegation?.map((eachInput, subIndex) => {
                      const initials = eachInput?.name
                        .split(" ")
                        .filter((word) => word.length > 0)
                        .map((word) => word.charAt(0).toUpperCase())
                        .slice(0, 2)
                        .join("");
                      return (
                        <li
                          key={subIndex}
                          className="list-none cursor-pointer py-1"
                          onClick={() =>
                            handleChecklistChange(null, {
                              target: { value: eachInput, name: "delegation" },
                            })
                          } // Pass index and person
                        >
                          <div className="flex justify-between items-center">
                            <div className="text-[#2999BC] text-12 font-400 flex pl-4 space-x-2">
                              <div className="bg-white text-12 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                {initials}
                              </div>
                              <p className="mb-1 ">{eachInput?.name}</p>
                            </div>
                            <div className="pr-6 mb-1">
                              <i class="bi bi-x-circle"></i>
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
                <div>
                  <h3 className="text-14 font-500 ml-4 pb-3">Suggestions</h3>
                </div>
                <ul className="pl-5 text-12 font-400 space-y-3 text-[#2999BC] h-[70px] overflow-y-auto">
                  {personTableData
                    ?.filter(
                      (eachInput) =>
                        eachInput?.name?.toLowerCase().includes(checklistPersonSearch?.toLowerCase() || "") &&
                        !checklistForm?.delegation?.some((eachValue) =>
                          eachValue?.name?.toLowerCase().includes(eachInput?.name?.toLowerCase())
                        )
                    )
                    .map((eachInput, subIndex) => {
                      const initials = eachInput?.name
                        .split(" ")
                        .filter((word) => word.length > 0)
                        .map((word) => word.charAt(0).toUpperCase())
                        .slice(0, 2)
                        .join("");
                      return (
                        <div className="flex space-x-2 cursor-pointer" key={subIndex}>
                          <div className="bg-white text-12 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                            {initials}
                          </div>
                          <li
                            onClick={() =>
                              handleChecklistChange(null, {
                                target: { value: eachInput, name: "delegation" },
                              })
                            }
                          >
                            {eachInput?.name}
                          </li>
                        </div>
                      );
                    })}
                </ul>
              </div>
            </div>
          </FloatingList>
        )}
      </div>
    </button>
  );

  const getDelegationComponentUpdated = () => (
    <div className="w-full">
      {/* {console.log(personTableData, "helloperson")} */}
      <SelectComponent
        options={personTableData?.map((option) => ({
          value: option.id,
          label: option.name,
          subLabel: option.email,
        }))}
        personList
        name="delegation"
        onChange={(e) => handleChecklistChange(null, e)}
        // onChange={(selected) =>
        //   handleChecklistChange(null, {
        //     target: {
        //       name: "delegation",
        //       value: selected?.value, // just the ID
        //     },
        //   })
        // }
        value={
          personTableData?.find((option) => option.id === checklistForm?.delegation?.[0])
            ? {
                value: checklistForm?.delegation?.[0],
                label: personTableData.find((option) => option.id === checklistForm?.delegation?.[0])?.name,
                subLabel: personTableData.find((option) => option.id === checklistForm?.delegation?.[0])?.email,
              }
            : null
        }
        size="small"
      />
    </div>
  );

  const getProjectFields = ({ projectFields, formData }) => (
    <>
      {projectFields
        ?.filter((item) => !item?.hide)
        .map((eachField) => (
          <div className={`basis-5/5 mb-1 col-span-${eachField.colspan ?? "2"}`}>
            {!eachField?.noLabel && (
              <label htmlFor="project_review_manager" className="block mb-1 text-lg text-434852">
                <span className={`text-sm ${isFormDisabled ? "text-6B6B6B" : "text-434852"}`}>{eachField?.label}</span>
                {eachField?.isMandatory && <span className="text-red-700"> *</span>}
              </label>
            )}
            <div className="flex items-center">
              {eachField?.type === "delegation" ? (
                getDelegationComponentUpdated()
              ) : (
                <FieldElements
                  id={eachField?.id}
                  name={eachField?.name}
                  label={eachField?.label}
                  value={eachField?.value || ""}
                  onChange={handleInputChange}
                  disabled={eachField?.disabled}
                  isFormDisabled={isFormDisabled}
                  // defaultOptions={selectionList}
                  type={eachField?.type}
                  onClick={() => {
                    // eachField?.type === "select" && handleClickItem(eachField?.name);
                  }}
                  formData={formData}
                  defaultOptions={eachField?.defaultOptions}
                  dynamicOptions={eachField?.dynamicOptions}
                  apiCall={eachField?.apiCall}
                  addButton={eachField?.addButton}
                  addButtonLabel={eachField?.addButtonLabel}
                  addButtonAction={eachField?.addButtonAction}
                  isLoading={eachField?.isLoading}
                  useFetchHook={eachField?.useFetchHook}
                  hookPayload={eachField?.hookPayload}
                />
              )}
            </div>
          </div>
        ))}
    </>
  );

  const handleEditChecklist = (value) => {
    setEditingChecklistId(value.id ? value.id : value.serial);

    if (checklistForm?.serial === value?.serial && checklistForm?.checklist_type === "new") {
      setChecklistForm(initialChecklistForm);
    } else if (checklistForm?.id === value?.id && checklistForm?.checklist_type !== "new") {
      setChecklistForm(initialChecklistForm);
    } else {
      setChecklistForm(value);
    }
  };

  const handleDeleteChecklist = (value) => {
    handleDeleteSubtask([value?.id || value?.serial], "checklist", value?.serial);
  };

  // const handleToggleTaskComplete = (index) => {
  //     const updatedTasks = [...formData.sub_tasks];
  //     const currentTask = updatedTasks[index];

  //     // If marking as Completed
  //     if (currentTask.status !== "Completed") {
  //       updatedTasks[index] = {
  //         ...currentTask,
  //         previous_status: currentTask.status, // save original status
  //         previous_status_color_code: currentTask.status_color_code,
  //         status: "Completed",
  //         status_color_code: "#37BE20",
  //       };
  //     } else {
  //       // If unchecking, revert to previous_status
  //       updatedTasks[index] = {
  //         ...currentTask,
  //         status: currentTask.previous_status || "Pending",
  //         status_color_code: currentTask.previous_status_color_code,
  //         previous_status: undefined, // clear the temporary storage
  //         previous_status_color_code: undefined,
  //       };
  //     }

  //     setFormData((prev) => ({
  //       ...prev,
  //       sub_tasks: updatedTasks,
  //     }));
  //   };

  useEffect(() => {
    fetchPersonData("");
  }, []);

  const HeaderAction = () => {
    return (
      <button
        className="bg-[#2999BC] text-[#FFFFFF] px-3 py-1 rounded-md text-base"
        onClick={() => {
          formData?.category_id?.toLowerCase() === "task" ? addSubtask() : addChecklist();
          setEditingChecklistId(null);
        }}
      >
        Save
      </button>
    );
  };

  return (
    <CustomDrawer
      subDrawer={subDrawer}
      open={open}
      onClose={onClose}
      headerText="Checklist"
      headerAction={HeaderAction()}
    >
      <div className="w-full h-full min-h-0 grow flex flex-col overflow-y-auto justify-center">
        <div
          className={`overflow-x-auto overflow-y-auto h-fit flex items-start justify-start p-3 bg-[#FFF] flex-col w-full min-h-fit rounded-md border border-[#BECBD3]`}
        >
          {[checklistForm]?.map((eachCheckList, index) => (
            <div className="grid grid-cols-2 gap-0 gap-x-2 w-full " key={index}>
              {getProjectFields({ projectFields: projectFields2, formData: eachCheckList })}
              {false && (
                <>
                  <span>
                    <label className="text-[#434852] font-poppins text-smfont-normal">FS item</label>
                    <InputComponent height={"25px"} placeholder="Enter FS Item Name" />
                  </span>

                  <span className="grid grid-cols-1">
                    <label className="text-[#434852] font-poppins text-smfont-normal">Activity</label>
                    {/* <FieldElements
                  id={"activity"}
                  name={"activity"}
                  label={"Activity"}
                  onChange={handleChecklistChange}
                  // disabled={eachField?.disabled}
                  // isFormDisabled={isFormDisabled}
                  // defaultOptions={selectionList}
                  type={"text"}
                  onClick={() => {
                    eachField?.type === "select" && handleClickItem(eachField?.name);
                  }}
                  formData={formData}
                  taskid={taskid}
                  defaultOptions={eachField?.defaultOptions}
                  dynamicOptions={eachField?.dynamicOptions}
                  apiCall={eachField?.apiCall}
                  addButton={eachField?.addButton}
                  addButtonLabel={eachField?.addButtonLabel}
                  addButtonAction={eachField?.addButtonAction}
                  isLoading={eachField?.isLoading}
                  useFetchHook={eachField?.useFetchHook}
                  hookPayload={eachField?.hookPayload}
                /> */}
                    <BasicSelect
                      showSearch
                      name="activity"
                      // value={eachCheckList?.activity}

                      id={"activity"}
                      options={[{ label: "labe1", value: "value 1" }]}
                      selectedOptions={[{ label: "labe1", value: "value 1" }]?.filter(
                        (eachOption) => checklistForm["activity"] === eachOption.value
                      )}
                      label="Activity"
                      onChange={handleChecklistChange}
                      // isLoading
                      // useFetchHook
                      // handleCallHook
                    />
                  </span>

                  <span className="grid grid-cols-1">
                    <label className="text-[#434852] font-poppins text-smfont-normal">Name</label>
                    <InputComponent height={"25px"} placeholder="Enter Name" />
                  </span>

                  <span>
                    <label className="flex items-center justify-start text-[#434852] font-poppins text-smfont-normal">
                      Type of issue
                    </label>
                    <BasicSelect
                      showSearch
                      name="typeOfIssue"
                      // value={eachCheckList?.activity}

                      id={"typeOfIssue"}
                      options={[{ label: "labe1", value: "value 1" }]}
                      selectedOptions={[{ label: "labe1", value: "value 1" }]?.filter(
                        (eachOption) => checklistForm["typeOfIssue"] === eachOption.value
                      )}
                      label="Type of Issue"
                      onChange={handleChecklistChange}
                      // isLoading
                      // useFetchHook
                      // handleCallHook
                    />
                  </span>

                  <span className="grid grid-cols-1">
                    <label className="text-[#434852] font-poppins text-smfont-normal">Delegation</label>
                    <button type="button" ref={taskassignedtoref} disabled={isFormDisabled} className="flex">
                      {/* <AddTaskProfileIcn /> */}
                      <div>
                        <div
                          onClick={(event) => {
                            taskassignedtoref.current = event.target.closest("button");
                            // handleMouseEnter(index);
                            setOpenAssignedTo(!openAssignedTo);
                            if (!openAssignedTo) fetchPersonData("");
                          }}
                        >
                          {checklistForm?.delegation?.length >= 1 ? (
                            <Fragment>
                              {checklistForm?.delegation
                                ?.filter((a, index) => index < 1)
                                .map((eachInput, subIndex) => {
                                  const initials = eachInput?.name
                                    .split(" ")
                                    .filter((word) => word.length > 0)
                                    .map((word) => word.charAt(0).toUpperCase())
                                    .slice(0, 2)
                                    .join("");

                                  const fullName = eachInput?.name;

                                  return (
                                    <Tooltip
                                      title={
                                        <>
                                          <div className="py-2 min-w-[249px]">
                                            <div className="rounded-lg bg-white">
                                              <div className="border-b-2 space-y-2 pb-2">
                                                <div className="flex px-2 space-x-2">
                                                  <div>
                                                    <div className=" flex justify-center items-center ">
                                                      <AvatarName
                                                        name={initials}
                                                        size="small"
                                                        bgColor={"#E8ECF299"}
                                                        textColor={"#7C7C83"}
                                                        borderColor={"#ABABAC"}
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="text-2999BC text-14">{fullName}</div>
                                                </div>

                                                <div className="flex px-2 space-x-2 my-2">
                                                  <div className="w-5 text-center">
                                                    <EmailIcon />
                                                  </div>
                                                  <div className="text-F16136 text-12">{eachInput?.email}</div>
                                                </div>

                                                <div className="flex px-2 space-x-2 my-2">
                                                  <div className="w-5 text-center">
                                                    <PhoneIcon />
                                                  </div>
                                                  <div className="text-F16136 text-12">
                                                    {eachInput?.mobile ? eachInput?.mobile : "Not Avaliable"}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="flex justify-end mt-2 me-5 text-12">
                                                <button
                                                  className="text-blue-500"
                                                  // onClick={(e) => toggleDetails(e, header, rowKey, eachInput)}
                                                >
                                                  {/* {isDetailsVisible ? "Show more" : "Show more"} */}
                                                  Show more
                                                </button>
                                              </div>
                                            </div>
                                            <div></div>
                                          </div>
                                        </>
                                      }
                                      PopperProps={{ style: { zIndex: 99999 } }}
                                      placement="top"
                                      arrow
                                      componentsProps={{
                                        tooltip: {
                                          sx: {
                                            bgcolor: "common.white",
                                            filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                            color: "#383838",
                                            "& .MuiTooltip-arrow": {
                                              color: "common.white",
                                              filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                            },
                                          },
                                        },
                                      }}
                                    >
                                      <div key={subIndex}>
                                        <AvatarName
                                          name={initials}
                                          size="medium"
                                          bgColor={eachInput?.c_key}
                                          textColor={"#ffffff"}
                                          borderColor={"#ffffff"}
                                        />
                                      </div>
                                    </Tooltip>
                                  );
                                })}
                            </Fragment>
                          ) : (
                            <AddProfileWithCircle />
                          )}
                        </div>
                        {openAssignedTo && (
                          <FloatingList>
                            <div className="w-[294px]  mt-2 bg-white rounded-md border shadow-3 pt-3 mb-6 absolute z-[1]">
                              <div onMouseLeave={() => setOpenAssignedTo(false)}>
                                <input
                                  type="text"
                                  placeholder="Type a name or email address"
                                  className="ml-2 w-[270px] h-[38px] border-[#B6BBBF] bg-[#F8F8F8] rounded-md text-[12px] font-[400] text-[#848687] mb-1"
                                  value={checklistPersonSearch || ""}
                                  onChange={handleChangeSearch}
                                />

                                <div className="pb-3 align-center">
                                  <h3 className="text-14 font-500 ml-4 mb-1">Assigned</h3>
                                  <ul className="list-none max-h-[70px] overflow-y-auto">
                                    {checklistForm?.delegation?.map((eachInput, subIndex) => {
                                      const initials = eachInput?.name
                                        .split(" ")
                                        .filter((word) => word.length > 0)
                                        .map((word) => word.charAt(0).toUpperCase())
                                        .slice(0, 2)
                                        .join("");
                                      return (
                                        <li
                                          key={subIndex}
                                          className="list-none cursor-pointer py-1"
                                          onClick={() =>
                                            handleSubtaskChange(index, {
                                              target: { value: eachInput, name: "delegation" },
                                            })
                                          } // Pass index and person
                                        >
                                          <div className="flex justify-between items-center">
                                            <div className="text-[#2999BC] text-12 font-400 flex pl-4 space-x-2">
                                              <div className="bg-white text-12 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                                {initials}
                                              </div>
                                              <p className="mb-1 ">{eachInput?.name}</p>
                                            </div>
                                            <div className="pr-6 mb-1">
                                              <i class="bi bi-x-circle"></i>
                                            </div>
                                          </div>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                                <div>
                                  <h3 className="text-14 font-500 ml-4 pb-3">Suggestions</h3>
                                </div>
                                <ul className="pl-5 text-12 font-400 space-y-3 text-[#2999BC] h-[70px] overflow-y-auto">
                                  {personTableData
                                    ?.filter(
                                      (eachInput) =>
                                        eachInput?.name
                                          ?.toLowerCase()
                                          .includes(checklistPersonSearch?.toLowerCase() || "") &&
                                        !checklistForm?.delegation?.some((eachValue) =>
                                          eachValue?.name?.toLowerCase().includes(eachInput?.name?.toLowerCase())
                                        )
                                    )
                                    .map((eachInput, subIndex) => {
                                      const initials = eachInput?.name
                                        .split(" ")
                                        .filter((word) => word.length > 0)
                                        .map((word) => word.charAt(0).toUpperCase())
                                        .slice(0, 2)
                                        .join("");
                                      return (
                                        <div className="flex space-x-2 cursor-pointer" key={subIndex}>
                                          <div className="bg-white text-12 font-600 border-[#AAC9DB] p-[10px] w-5 h-5 flex items-center justify-center rounded-full border-[1px]">
                                            {initials}
                                          </div>
                                          <li
                                            onClick={() =>
                                              handleChecklistChange(index, {
                                                target: { value: eachInput, name: "delegation" },
                                              })
                                            }
                                          >
                                            {eachInput?.name}
                                          </li>
                                        </div>
                                      );
                                    })}
                                </ul>
                              </div>
                            </div>
                          </FloatingList>
                        )}
                      </div>

                      {/* <input
                                      value={subtask?.delegation?.[0]?.name}
                                      className={` rounded border  ${isFormDisabled ? "border-DFE2E5 bg-EDEDED text-868686" : "border-DFE2E5 bg-white text-434852"} focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-xs block w-full h-7 px-2`}
                                    />
                                    <span className="absolute inset-y-0 right-0 flex items-center">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="35"
                                        height="35"
                                        viewBox="0 0 45 36"
                                        fill="none"
                                      >
                                        <path
                                          d="M0.5 1H40C42.4853 1 44.5 3.01472 44.5 5.5V30.5C44.5 32.9853 42.4853 35 40 35H0.5V1Z"
                                          fill="#F0F0F0"
                                          stroke="#DFE2E5"
                                        />
                                        <path
                                          d="M22.3714 18.1341C23.7199 18.1341 24.8874 17.6594 25.8416 16.7228C26.7955 15.7864 27.2793 14.6406 27.2793 13.3169C27.2793 11.9937 26.7956 10.8477 25.8414 9.91098C24.8872 8.9747 23.7197 8.5 22.3714 8.5C21.0228 8.5 19.8555 8.9747 18.9014 9.91113C17.9474 10.8476 17.4636 11.9935 17.4636 13.3169C17.4636 14.6406 17.9474 15.7865 18.9014 16.723C19.8558 17.6592 21.0233 18.1341 22.3714 18.1341ZM19.7459 10.7398C20.478 10.0213 21.3367 9.67203 22.3714 9.67203C23.406 9.67203 24.2649 10.0213 24.9971 10.7398C25.7292 11.4585 26.0852 12.3016 26.0852 13.3169C26.0852 14.3325 25.7292 15.1754 24.9971 15.8941C24.2649 16.6128 23.406 16.9621 22.3714 16.9621C21.337 16.9621 20.4783 16.6126 19.7459 15.8941C19.0137 15.1756 18.6577 14.3325 18.6577 13.3169C18.6577 12.3016 19.0137 11.4585 19.7459 10.7398Z"
                                          fill="#545F65"
                                        />
                                        <path
                                          d="M30.9588 23.879C30.9313 23.4893 30.8756 23.0642 30.7937 22.6153C30.711 22.163 30.6045 21.7355 30.477 21.3447C30.3452 20.9408 30.1663 20.5419 29.9447 20.1597C29.7151 19.763 29.4453 19.4175 29.1424 19.1332C28.8258 18.8358 28.438 18.5967 27.9897 18.4223C27.5429 18.2488 27.0478 18.1609 26.5181 18.1609C26.3101 18.1609 26.109 18.2447 25.7205 18.493C25.4814 18.646 25.2017 18.823 24.8896 19.0188C24.6226 19.1857 24.261 19.3421 23.8144 19.4837C23.3787 19.6221 22.9362 19.6923 22.4994 19.6923C22.0629 19.6923 21.6204 19.6221 21.1844 19.4837C20.7382 19.3423 20.3764 19.1859 20.11 19.019C19.8008 18.825 19.521 18.648 19.2783 18.4928C18.8901 18.2446 18.6889 18.1608 18.4809 18.1608C17.9511 18.1608 17.4562 18.2488 17.0095 18.4225C16.5615 18.5966 16.1736 18.8357 15.8566 19.1334C15.5538 19.4178 15.2839 19.7631 15.0545 20.1597C14.8333 20.5419 14.6542 20.9406 14.5223 21.3448C14.395 21.7356 14.2885 22.163 14.2058 22.6153C14.1237 23.0636 14.0682 23.4889 14.0407 23.8795C14.0137 24.2614 14 24.6589 14 25.0605C14 26.1045 14.3381 26.9497 15.0049 27.573C15.6634 28.1881 16.5346 28.5 17.5944 28.5H27.4056C28.4651 28.5 29.3363 28.1881 29.995 27.573C30.6619 26.9502 31 26.1047 31 25.0604C30.9998 24.6574 30.986 24.2599 30.9588 23.879ZM29.1717 26.7239C28.7365 27.1304 28.1588 27.328 27.4055 27.328H17.5944C16.8408 27.328 16.2632 27.1304 15.8282 26.724C15.4015 26.3253 15.1941 25.781 15.1941 25.0605C15.1941 24.6858 15.2067 24.3157 15.2319 23.9605C15.2564 23.612 15.3066 23.2292 15.3811 22.8224C15.4546 22.4206 15.5482 22.0435 15.6595 21.7022C15.7663 21.3749 15.912 21.0508 16.0926 20.7386C16.265 20.4411 16.4634 20.1858 16.6823 19.9801C16.887 19.7877 17.1451 19.6302 17.4492 19.5121C17.7304 19.4029 18.0464 19.343 18.3895 19.334C18.4313 19.3559 18.5058 19.3975 18.6264 19.4747C18.8719 19.6317 19.1548 19.8109 19.4676 20.007C19.8202 20.2276 20.2745 20.4269 20.8172 20.5988C21.372 20.7749 21.9379 20.8643 22.4995 20.8643C23.0612 20.8643 23.6272 20.7749 24.1817 20.599C24.7249 20.4267 25.179 20.2276 25.5321 20.0067C25.8521 19.8058 26.1272 19.6319 26.3726 19.4747C26.4933 19.3977 26.5677 19.3559 26.6095 19.334C26.9528 19.343 27.2688 19.4029 27.5502 19.5121C27.8541 19.6302 28.1122 19.7878 28.3169 19.9801C28.5358 20.1856 28.7342 20.4409 28.9066 20.7388C29.0874 21.0508 29.2332 21.3751 29.3399 21.7021C29.4513 22.0439 29.5451 22.4207 29.6184 22.8222C29.6927 23.2298 29.7431 23.6128 29.7677 23.9607V23.961C29.793 24.3148 29.8058 24.6847 29.8059 25.0605C29.8058 25.7812 29.5984 26.3253 29.1717 26.7239Z"
                                          fill="#545F65"
                                        />
                                      </svg>
                                    </span>
                                    <span className={`text-red-700 absolute inset-y-0 right-1 flex items-center`}>
                                      *
                                    </span> */}
                    </button>
                  </span>
                  <span className="grid grid-cols-1">
                    <label className="text-[#434852] font-poppins text-smfont-normal">Status</label>
                    <BasicSelect
                      showSearch
                      name="status"
                      // value={eachCheckList?.activity}

                      id={"status"}
                      options={[{ label: "labe1", value: "value 1" }]}
                      selectedOptions={[{ label: "labe1", value: "value 1" }]?.filter(
                        (eachOption) => checklistForm["status"] === eachOption.value
                      )}
                      label="Status"
                      onChange={handleChecklistChange}
                      // isLoading
                      // useFetchHook
                      // handleCallHook
                    />
                  </span>
                </>
              )}
            </div>
          ))}
        </div>

        <div className="py-4 flex">
          <p className="text-[#434852] text-lg font-poppins font-500">
            CheckList{" "}
            <span className="text-[#F84545]">
              {" "}
              {formData?.checklists?.length ? `(${formData.checklists.length})` : ""}
            </span>
          </p>
        </div>

        <div
          className={`w-full min-h-0 grow flex flex-col ${formData?.checklists?.length ? "items-start justify-start" : "items-center justify-center"}  overflow-x-hidden bg-white rounded-md border border-[#DFE2E5] thinscrollbar`}
        >
          {formData?.checklists?.length ? (
            formData?.checklists?.map((item, index) => {
              const isBeingEdited = item.id === editingChecklistId || item.serial === editingChecklistId;
              return (
                // console.log(item, personTableData, "item?.Color"),
                <>
                  <div
                    key={index}
                    className={`w-full flex flex-col justify-between px-4 py-3 border-b group transition-colors duration-150 ${
                      isBeingEdited ? "bg-gray-200 pointer-events-none opacity-80" : "hover:bg-[#EBF2F6] bg-white"
                    }`}
                    style={{
                      backgroundColor:
                        item?.checklist_type === "new"
                          ? item?.serial === checklistForm?.serial
                          : item?.id === checklistForm?.id
                            ? "lightgrey"
                            : "",
                    }}
                  >
                    <div className="flex items-start gap-2 w-full">
                      <div className="py-[2px]" onClick={() => handleToggleTaskComplete(index)}>
                        <CompletionCheckbox isChecked={item.status?.toLowerCase() === "completed"} size="small" />
                      </div>

                      <div className="flex items-start flex-col gap-1.5 w-full overflow-auto">
                        <span className="text-[#1D4469] font-poppins text-sm font-medium capitalize w-full truncate">
                          {item?.fs_item || "--"}
                        </span>
                        <div className="flex items-center justify-start gap-2">
                          <ActivityIcon />
                          <span className="text-[#383838] font-poppins text-xs font-normal  capitalize">
                            {item?.activity || "--"}
                          </span>
                        </div>
                        <div className="flex items-center justify-start gap-2">
                          <PencilIcon />
                          <span className="text-[#383838] font-poppins text-xs font-normal  capitalize">
                            {item?.name || "--"}
                          </span>
                        </div>
                        <div className="flex items-center justify-start gap-2">
                          <StopIconGrey />
                          <span className="text-[#383838] font-poppins text-xs font-normal  capitalize">
                            {item?.type_of_issue || "--"}
                          </span>
                        </div>
                        <div className="flex items-center justify-start gap-2">
                          <ProfileIcon className="h-[14px] w-[12px]" />
                          <span className="text-[#666666] font-poppins text-sm font-normal  capitalize">
                            {item?.delegation?.[0]?.name || "--"}
                            {/* <AvatarName
                                name={getInitials(item?.delegation?.[0]?.name)}
                                size="medium"
                                bgColor={"#E8ECF299"}
                                textColor={"#7C7C83"}
                                borderColor={"#ABABAC"}
                              /> */}
                          </span>
                        </div>

                        <div className="flex w-full items-center justify-between gap-2 ">
                          <div className="flex gap-2">
                            <button
                              className={`flex items-center text-sm justify-centre px-2 py-1 border-[0.8px]  rounded-md`}
                              style={{
                                backgroundColor: `${item?.status_color_code}33`,
                                color: `${item?.status_color_code}`,
                                borderColor: `${item?.status_color_code}`,
                              }}
                            >
                              {item?.status}
                            </button>
                          </div>

                          <div className=" flex justify-end gap-2 invisible group-hover:visible">
                            <CircleEdit className="cursor-pointer" onClick={() => handleEditChecklist(item)} />
                            <CircleDelete className="cursor-pointer" onClick={() => handleDeleteChecklist(item)} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <p className="text-[#888888] text-base font-400 font-poppins">No Checklist Available!!</p>
          )}
        </div>
      </div>
    </CustomDrawer>
  );
};

// <>
//                 <div
//                   key={index}
//                   className=" w-full flex items-center justify-between border-b-2 py-2 group  px-3 hover:bg-[#EBF2F680]"
//                 >
//                   <div className=" w-full overflow-auto">
//                     <h4 className="text-[#1D4469] font-poppins text-xm font-medium capitalize  w-full truncate">
//                       {item.projectName}
//                     </h4>
//                     <div className="flex items-center justify-start gap-2">
//                       <span className="text-[#383838] font-poppins text-sm font-normal  capitalize">
//                         {item.RepoBank}
//                       </span>
//                       <span className=" h-4 border border-lg border-[#969BA9] "></span>
//                       <span className="text-[#969BA9] font-poppins text-sm font-normal  capitalize">
//                         {item.CitiBank}
//                       </span>
//                     </div>
//                     <div className="flex items-center justify-start gap-2">
//                       <span className="text-[#2999BC] font-poppins text-sm font-normal  capitalize">{item.None}</span>
//                       <span className=" h-4 border border-[#2999BC] rotate-[25deg]"></span>
//                       <span className="text-[#2999BC] font-poppins text-sm font-normal  capitalize">
//                         {item.Document}
//                       </span>
//                     </div>
//                     <div className="flex items-center justify-centre gap-2 mt-1">
//                       <button
//                         className={`flex items-center text-sm justify-centre px-2 py-1 text-[${item?.Color}] border-[0.8px]  rounded-md`}
//                         style={{
//                           backgroundColor: `${item?.Color}33`,
//                           color: `${item?.Color}`,
//                           borderColor: `${item?.Color}`,
//                         }}
//                       >
//                         {item.Stage}
//                       </button>
//                       <span
//                         className={`text-white text-md  w-7 h-7 flex items-center justify-center rounded-full cursor-pointer`}
//                         style={{ backgroundColor: `${item.InitialColor}` }}
//                       >
//                         {getInitials(item.Initial)}
//                       </span>
//                     </div>
//                   </div>

//                   <div className=" h-full flex items-end justify-end gap-2 invisible group-hover:visible">
//                     <CircleEdit className="cursor-pointer" />
//                     <CircleDelete className="cursor-pointer" />
//                   </div>
//                 </div>
//               </>
